<template>
  <div v-if="shouldShow">
    <slot />
  </div>
</template>

<script>
import { computed, inject} from "vue";
export default {
  name: "FormStep",
  props: {
    title: {
      type: String,
      required: true
    },
    beforeChange: {
      type: Function
    }
  },
  setup(props) {
    // This is a ref injected from FormWizard
    // clones the step index to get the step's index and advances it by 1 for the next step
    // meaning each step gets a index id starting from 1
    const indexForThisStep = inject("STEP_COUNTER").value++;
    // Grabs the live ref to the current form active step
    const currentStep = inject("CURRENT_STEP");

    inject("FORM_STEPS").value[indexForThisStep] = {
      title: props.title,
      beforeChange: props.beforeChange,
      checked: indexForThisStep === 0
    };

    // If this step should be shown
    const shouldShow = computed(() => {
      return indexForThisStep === currentStep.value;
    });
    
    return {
      shouldShow
    };
  }
}
</script>

<style>

</style>